import moment from "moment";

/**
 * Format mata uang Rupiah IDR tanpa desimal (contoh: "Rp 1.500.000")
 * @param {number|string} amount
 * @returns {string}
 */
export const formatCurrencyIDR = (amount) => {
  const num = Number(amount) || 0;
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(num);
};

/**
 * Format string label select option transaksi:
 * [profit_center] DD/MM/YYYY - produk - name - phone - harga
 *
 * @param {Object} tx
 * @returns {string}
 */
export const formatTransactionOptionLabel = (tx = {}) => {
  // 1. Tampilkan profit_center langsung dari response API
  const profitCenter = tx.profit_center || "-";
  const tag = `[${profitCenter}]`;

  // 2. Tanggal (DD/MM/YYYY)
  const rawDate = tx.transaction_date || tx.created_at;
  const dateStr =
    rawDate && moment(rawDate).isValid()
      ? moment(rawDate).format("DD/MM/YYYY")
      : "-";

  // 3. Nama produk
  const product = (tx.product || "").trim() || "-";

  // 4. Name
  const name = (tx.client_name || "").trim() || "-";

  // 5. Phone
  const phone = (tx.client_phone || "").trim() || "-";

  // 6. Harga (Rp X.XXX.XXX)
  const price = formatCurrencyIDR(tx.amount || 0);

  return `${tag} ${dateStr} - ${product} - ${name} - ${phone} - ${price}`;
};

/**
 * Pecah transaksi jadi daftar produk untuk payload crm resolve:
 * [{ id: 301, productName: "[ASHOP]-Kaos Astronacci", price: "350000.00" }, ...]
 * id diambil dari product_id ("301, 305").
 *
 * @param {Object} tx
 * @returns {Array<{id: number, productName: string, price: string}>}
 */
export const toResolveProducts = (tx = {}) => {
  const ids = String(tx.product_id || "")
    .split(",")
    .map((s) => Number(s.trim()))
    .filter(Boolean);
  const names = String(tx.product || "").split(",").map((s) => s.trim());
  const total = (Number(tx.amount) || 0).toFixed(2);
  const prefix = tx.profit_center ? `[${tx.profit_center}]-` : "";

  return ids.map((id, i) => ({
    id,
    productName: prefix + (names.length === ids.length ? names[i] : tx.product || ""),
    // ponytail: amount = total order, API belum kirim harga per produk; total ditaruh di produk pertama agar jumlahnya tetap benar
    price: i === 0 ? total : "0.00",
  }));
};
